function HowSection() {
    const issues1 = [
        "Stress",
        "Anxiety",
        "Relationship difficulties",
        "Family issues",
        "Grief & loss",
        "Addictive behaviours",
        "Self-sabotage",
        "Life transitions",
        "Spirituality"];
    const issues2 = [
        "Complex trauma",
        "Childhood abuse & neglect",
        "Depression",
        "Self-esteem issues",
        "Social anxiety",
        "Issues with anger",
        "Sexuality",
        "Issues around masculinity",
        "Meaning & purpose"
    ];

    return (
        <section className="section-colour">
            <div className="how-section">
                <h3>What issues can therapy help with?</h3>
                <div className="issue-list">
                    <div className="list1">
                        {issues1.map((issue, i) => {
                            return <div key={i} className="paragraph">{issue}</div>
                        })}
                    </div>
                    <div className="list2">
                        {issues2.map((issue, j) => {
                            return <div key={j} className="paragraph">{issue}</div>
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default HowSection;